export const INVENTORY_TEMPLATE_SORT_ALPHABETICALLY_STORAGE_KEY = 'inventoryTemplateVariantsSelector.sortAlphabetically';

export const readInventoryTemplateSortAlphabetically = (): boolean => {
    try {
        const stored = localStorage.getItem(INVENTORY_TEMPLATE_SORT_ALPHABETICALLY_STORAGE_KEY);
        if (stored === null) {
            return true;
        }
        return stored === 'true';
    } catch {
        return true;
    }
};

export const writeInventoryTemplateSortAlphabetically = (value: boolean): void => {
    try {
        localStorage.setItem(INVENTORY_TEMPLATE_SORT_ALPHABETICALLY_STORAGE_KEY, String(value));
    } catch {
        // ignore storage errors
    }
};
